import { render, staticRenderFns } from "./Rotinas.vue?vue&type=template&id=1c251e44&"
import script from "./Rotinas.vue?vue&type=script&lang=js&"
export * from "./Rotinas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports